export const setAlert = (message, type) => ({
  type: "SET_ALERT",
  payload: { message, type },
});

export const removeAlert = () => ({
  type: "REMOVE_ALERT",
});
